/**
 * React Router v6 emits a console warning for every v7 behaviour that is not opted into.
 * Opting in now keeps the console clean and means the eventual v7 upgrade is a version bump
 * rather than a behavioural change.
 */
export const ROUTER_FUTURE = {
  v7_relativeSplatPath: true,
  v7_fetcherPersist: true,
  v7_normalizeFormMethod: true,
  v7_partialHydration: true,
  v7_skipActionErrorRevalidation: true,
} as const;
